module.exports = __webpack_public_path__ + "static/media/email.6571949b.svg";